
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { auth, session } from '../../utils/AuthSession'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import { ToastContainer, toast } from 'react-toastify';
import { useForm, SubmitHandler } from "react-hook-form"
import moment from 'moment'
import { useNavigate, useLocation } from 'react-router-dom'
import DatePicker from 'react-mobile-datepicker';
import { ThemeContext } from '../../context/ThemeContext';
import { Card } from 'react-daisyui'
import { getMemberAddresses } from '../../utils/memberAddress'
import {
    getVoucherDiscountAmount,
    getVoucherDiscountMeta,
    normalizeVoucherCompanySlug,
    voucherMatchesCompany,
    voucherMatchesItems
} from '../../utils/voucherDiscount'
import {
    isMidtransGateway,
    isSafePaymentRedirectUrl,
    isXenditGateway,
    normalizePaymentIdentifier,
    paymentGatewayPresentValue,
    paymentGatewayRedirectUrl
} from '../../utils/paymentGateway'
import { checkoutPreviewSummary, compareCheckoutPreview, localCheckoutSummary } from '../../utils/checkoutTransaction'
import MidT from '../../components/MidT'
import QrisPaymentModal from '../../components/QrisPaymentModal'
const CryptoJS = require("crypto-js");

const isPaymentOption = (paymentOption) =>
    Boolean(paymentOption?.ms_payment_id) && Boolean(normalizePaymentIdentifier(paymentOption?.ms_payment_identifier))
const paymentDisplayName = (paymentOption) => {
    const identifier = normalizePaymentIdentifier(paymentOption?.ms_payment_identifier)
    const channelCode = `${paymentOption?.public_configuration?.default_channel_code || ''}`.trim().toUpperCase()
    if (identifier === 'XENDIT' && channelCode === 'QRIS') return 'QRIS'
    return paymentOption?.ms_payment_name || identifier || '-'
}
const generateCheckoutRequestId = () => {
    if (window?.crypto?.randomUUID) return window.crypto.randomUUID()
    return `checkout-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

const Order = () => {
    const [Auth, setAuth] = useState()
    const [carts, setCarts] = useState([])
    const [checkoutLoading, setCheckoutLoading] = useState(false)
    const [address, setAddress] = useState([])
    const [selectedAdderss, setSelectedAddress] = useState()
    const [total, setTotal] = useState(0)
    const [shipping, setShipping] = useState({ costs: [] })
    const [selectedShipping, setSelectedShipping] = useState()
    const [providerStoreName, setProviderStoreName] = useState(null)
    const [Store, setStore] = useState()
    const [ms_payment, setMsPayment] = useState([])
    const [store_payment, setStorePayment] = useState([])
    const [optionPayment, setOptionPayment] = useState([])
    const [selectedPayment, setSelectedPayment] = useState()
    const [my_vouchers, setMyVouchers] = useState([])
    const [globalVouchers, setGlobalVouchers] = useState([])
    const [selectedVoucher, setSelectedVoucher] = useState()
    const [masterDelivery, setMasterDelivery] = useState([])
    const [delivery, setDelivery] = useState([])
    const [selectedDelivery, setSelectedDelivery] = useState()
    const [transactionDeliveryNote, setTransactionDeliveryNote] = useState('')
    const [validParams, setValidParams] = useState(false)
    const [storeLoading, setStoreLoading] = useState(false)
    const [addressGuardChecked, setAddressGuardChecked] = useState(false)
    const [isAgreementChecked, setIsAgreementChecked] = useState(false)
    const [serverPreview, setServerPreview] = useState(null)
    const [paymentToken, setPaymentToken] = useState(null)
    const [qrisPayment, setQrisPayment] = useState(null)
    const [walletSummary, setWalletSummary] = useState(null)
    const [useBalance, setUseBalance] = useState(false)
    const [balanceAmount, setBalanceAmount] = useState('')
    const [balanceAllocation, setBalanceAllocation] = useState(null)
    const [balanceConfirmationToken, setBalanceConfirmationToken] = useState('')
    const [updatingCartIds, setUpdatingCartIds] = useState(() => new Set())
    const checkoutSubmittingRef = useRef(false)
    const checkoutRequestIdRef = useRef(null)
    const orderInitializationStartedRef = useRef(false)
    const initialCartLoadKeyRef = useRef('')
    const balanceTokenResolverRef = useRef(null)
	const deliveryScheduleResolverRef = useRef(null)
	const afterPaymentScheduleBusyRef = useRef(false)
	const [deliverySchedule, setDeliverySchedule] = useState(null)
	const [deliveryScheduledAt, setDeliveryScheduledAt] = useState('')
	const [deliveryScheduleMode, setDeliveryScheduleMode] = useState('before_payment')

    const requestBalanceToken = () => new Promise((resolve) => {
        balanceTokenResolverRef.current = resolve
        setBalanceConfirmationToken('')
        document.getElementById('balance_confirmation_modal')?.showModal()
    })

	const requestDeliverySchedule = (schedule, mode = 'before_payment') => new Promise((resolve) => {
		deliveryScheduleResolverRef.current = resolve
		setDeliveryScheduleMode(mode)
		setDeliverySchedule(schedule)
		const earliest = schedule?.earliest_schedule_at ? new Date(schedule.earliest_schedule_at) : null
		const toLocalInput = (date) => date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16) : ''
		setDeliveryScheduledAt(toLocalInput(earliest))
		setTimeout(() => document.getElementById('delivery_schedule_modal')?.showModal(), 0)
	})

	const deliveryScheduleBounds = () => {
		const toLocalInput = (value) => {
			if (!value) return ''
			const date = new Date(value)
			return Number.isNaN(date.getTime()) ? '' : new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16)
		}
		return { min: toLocalInput(deliverySchedule?.earliest_schedule_at), max: toLocalInput(deliverySchedule?.latest_schedule_at) }
	}

	const isDeliveryScheduleSelectionValid = () => {
		if (!deliveryScheduledAt) return false
		const selected = new Date(deliveryScheduledAt).getTime()
		const start = new Date(deliverySchedule?.earliest_schedule_at).getTime()
		const end = new Date(deliverySchedule?.latest_schedule_at).getTime()
		return Number.isFinite(selected) && Number.isFinite(start) && Number.isFinite(end) && selected >= start && selected <= end
	}

    const { primaryColor, primaryColorHover } = useContext(ThemeContext)
    const canLoadOrder = validParams && addressGuardChecked

    useEffect(() => {
        Api({ access: 'auth', url: API.WALLET.url, method: API.WALLET.type, reqBody: {} })
            .then((result) => { if (result?.status) setWalletSummary(result.data) })
    }, [])

    const formatIDR = (val = 0) => `Rp ${Intl.NumberFormat('en-ID').format(val)}`
    const toNullableNumber = (value) => {
        if (value === null || value === undefined) return null
        if (typeof value === 'string' && value.trim() === '') return null
        const parsed = Number(value)
        return Number.isFinite(parsed) ? parsed : null
    }
    const toCoordinateNumber = (value) => {
        if (value === null || value === undefined) return null
        if (typeof value === 'string' && value.trim() === '') return null
        const parsed = Number(value)
        return Number.isFinite(parsed) ? parsed : null
    }
    const parseCoordinateString = (value) => {
        if (typeof value !== 'string') return null
        const [latitudeText, longitudeText] = value.split(',').map((part) => part.trim())
        if (!latitudeText || !longitudeText) return null
        const lat = toCoordinateNumber(latitudeText)
        const lng = toCoordinateNumber(longitudeText)
        if (lat === null || lng === null) return null
        if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null
        return { lat, lng }
    }
    const resolveCoordinatePair = (source) => {
        if (!source || typeof source !== 'object') return null

        const stringCandidates = [
            source?.coordinate,
            source?.store_coordinate,
            source?.location_coordinate
        ]
        for (const candidate of stringCandidates) {
            const parsed = parseCoordinateString(candidate)
            if (parsed) return parsed
        }

        const lat = [
            source?.latitude,
            source?.lat,
            source?.store_latitude,
            source?.coordinate_lat,
            source?.address_latitude
        ].map((candidate) => toCoordinateNumber(candidate)).find((candidate) => candidate !== null)

        const lng = [
            source?.longitude,
            source?.lng,
            source?.long,
            source?.store_longitude,
            source?.coordinate_lng,
            source?.address_longitude
        ].map((candidate) => toCoordinateNumber(candidate)).find((candidate) => candidate !== null)

        if (lat === undefined || lat === null || lng === undefined || lng === null) return null
        if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null

        return { lat, lng }
    }
    const formatCoordinateForApi = (coordinate) => {
        if (!coordinate) return ''
        if (!Number.isFinite(coordinate.lat) || !Number.isFinite(coordinate.lng)) return ''
        return `${coordinate.lat.toFixed(6)},${coordinate.lng.toFixed(6)}`
    }
    const isGoSendDelivery = (deliveryOption) => {
        const normalizeDeliveryText = (value) =>
            `${value || ''}`.toUpperCase().replace(/[^A-Z0-9]/g, '')

        const identifier = normalizeDeliveryText(deliveryOption?.ms_delivery_identifier)
        const name = normalizeDeliveryText(deliveryOption?.ms_delivery_name || deliveryOption?.label)

        return (
            identifier.includes('GOSEND') ||
            name.includes('GOSEND') ||
            identifier.includes('GOKILAT') ||
            name.includes('GOKILAT')
        )
    }
    const getShippingPriceValue = (shippingOption) => {
        const candidates = [
            shippingOption?.cost?.[0]?.value,
            shippingOption?.price?.total_price,
            shippingOption?.total_price,
            shippingOption?.amount
        ]

        for (const candidate of candidates) {
            const parsed = toNullableNumber(candidate)
            if (parsed !== null) return parsed
        }

        return 0
    }
    const getShippingLabel = (shippingOption) => {
        return shippingOption?.description || shippingOption?.shipment_method || shippingOption?.service || '-'
    }
    const toIdNumber = (value) => {
        const parsed = Number(value)
        return Number.isFinite(parsed) ? parsed : null
    }
    const mapPaymentOption = (paymentItem) => ({
        value: paymentItem?.ms_payment_id,
        label: paymentItem?.ms_payment_name,
        ms_payment_id: paymentItem?.ms_payment_id,
        ms_payment_name: paymentItem?.ms_payment_name,
        ms_payment_identifier: paymentItem?.ms_payment_identifier,
        public_configuration: paymentItem?.public_configuration || {},
        configuration_source: paymentItem?.configuration_source || null
    })
    const mapDeliveryOption = (deliveryItem) => ({
        value: deliveryItem?.ms_delivery_id,
        label: deliveryItem?.ms_delivery_name,
        ms_delivery_id: deliveryItem?.ms_delivery_id,
        ms_delivery_name: deliveryItem?.ms_delivery_name,
        ms_delivery_identifier: deliveryItem?.ms_delivery_identifier
    })
    const getShippingSubtitle = (shippingOption) => {
        const etdValue = shippingOption?.cost?.[0]?.etd
        if (etdValue !== undefined && etdValue !== null && `${etdValue}`.trim() !== '') {
            return `${etdValue} hari`
        }

        const distanceValue = toNullableNumber(shippingOption?.distance)
        if (distanceValue !== null) {
            return `${distanceValue} km`
        }

        return ''
    }
    const normalizeGoSendCosts = (gosendData) => {
        if (!gosendData || typeof gosendData !== 'object') return []

        return Object.entries(gosendData)
            .map(([serviceKey, service]) => {
                const shipmentMethod = `${serviceKey || service?.shipment_method || ''}`.trim()
                const shipmentMethodLabel = service?.shipment_method || shipmentMethod
                const totalPrice = toNullableNumber(service?.price?.total_price)
                if (!shipmentMethod || totalPrice === null) return null
                if (service?.active === false || service?.serviceable === false) return null

                return {
                    ...service,
                    shipment_method: shipmentMethod,
                    shipment_method_label: shipmentMethodLabel,
                    service: shipmentMethod,
                    description: shipmentMethodLabel,
                    cost: [{ value: totalPrice, etd: '' }],
                    source: 'gosend'
                }
            })
            .filter(Boolean)
    }
    const isInstantShipping = (shippingOption) => [
        shippingOption?.service,
        shippingOption?.shipment_method,
        shippingOption?.description
    ].some((value) => `${value || ''}`.trim().toUpperCase() === 'INSTANT')
    const firstTruthy = (...values) => values.find((value) => value !== undefined && value !== null && `${value}`.trim() !== '')
    const resolvePartnerId = (authPayload) => {
        const currentSession = session()
        return firstTruthy(
            authPayload?.data?.partner_id,
            authPayload?.partner_id,
            authPayload?.data?.data?.partner_id,
            authPayload?.data?.user?.partner_id,
            currentSession?.partner_id,
            currentSession?.user?.partner_id
        )
    }
    const resolveMemberId = (authPayload) => {
        const currentSession = session()
        return firstTruthy(
            authPayload?.data?.member_id,
            authPayload?.member_id,
            authPayload?.data?.data?.member_id,
            authPayload?.data?.user?.member_id,
            currentSession?.member_id,
            currentSession?.user?.member_id
        )
    }
    const resolveAddressCityId = (addressItem) =>
        firstTruthy(
            addressItem?.city_id,
            addressItem?.ms_city_id,
            addressItem?.cityId,
            addressItem?.city?.id,
            addressItem?.city?.city_id
        )
    const normalizeAddressText = (value) => `${value || ''}`.replace(/\s+/g, ' ').trim()
    const composeShippingDestinationAddress = (addressItem) => {
        const segments = [
            normalizeAddressText(addressItem?.full_address),
            normalizeAddressText(addressItem?.city_name),
            normalizeAddressText(addressItem?.province_name),
            normalizeAddressText(addressItem?.postal_code)
        ].filter((segment) => Boolean(segment))

        return segments.join(' ').trim()
    }
    const composeShippingDestinationCoordinate = (addressItem) => {
        const coordinate = resolveCoordinatePair(addressItem)
        const coordinateText = formatCoordinateForApi(coordinate)
        return coordinateText || ''
    }
    const pickStoreBySlug = (stores = [], slug = '') => {
        if (!Array.isArray(stores) || stores.length === 0) return null
        const targetSlug = `${slug || ''}`.trim().toLowerCase()
        if (!targetSlug) return stores[0]

        return (
            stores.find((storeItem) => `${storeItem?.store_slug || ''}`.trim().toLowerCase() === targetSlug) ||
            stores.find((storeItem) => `${storeItem?.slug || ''}`.trim().toLowerCase() === targetSlug) ||
            null
        )
    }
    const normalizeStoreFromResponse = (response, slug = '') => {
        if (!response || typeof response !== 'object') return null

        const data = response?.data

        if (Array.isArray(data)) {
            return pickStoreBySlug(data, slug) || null
        }

        if (Array.isArray(data?.data)) {
            return pickStoreBySlug(data.data, slug) || null
        }

        if (data?.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
            return data.data
        }

        if (
            data &&
            typeof data === 'object' &&
            !Array.isArray(data) &&
            (data?.store_id || data?.store_slug || data?.store_name)
        ) {
            return data
        }

        return null
    }
    const resolveCheckoutCompanySlug = (storeData) => {
        return [
            storeData?.company?.company_slug,
            storeData?.company_slug
        ]
            .map(normalizeVoucherCompanySlug)
            .find(Boolean) || ''
    }
    const applyStoreData = (storeData) => {
        setStore(storeData)
        setProviderStoreName(storeData?.store_name || null)
    }
    const FnStore = async (partnerId) => {
        if (!storeSlug) return
        setStoreLoading(true)

        const primaryParams = {
            access: 'public',
            method: API.PUBLIC_STORE.type,
            url: API.PUBLIC_STORE.url,
            reqBody: {
                store_slug: storeSlug
            }
        }

        try {
            const primaryResponse = await Api(primaryParams)
            if (primaryResponse?.status) {
                const normalizedStore = normalizeStoreFromResponse(primaryResponse, storeSlug)
                if (normalizedStore) {
                    applyStoreData(normalizedStore)
                    setStoreLoading(false)
                    return
                }
            }
        } catch (error) {
            // fallback handled below
        }

        const fallbackParams = {
            access: 'auth',
            method: API.STORE.type,
            url: API.STORE.url,
            reqBody: partnerId ? { partner_id: partnerId } : {}
        }

        if (!partnerId) {
            setStoreLoading(false)
            return
        }

        try {
            const fallbackResponse = await Api(fallbackParams)
            const fallbackStore = normalizeStoreFromResponse(fallbackResponse, storeSlug)
            if (fallbackResponse?.status && fallbackStore) {
                applyStoreData(fallbackStore)
                setStoreLoading(false)
                return
            }

            if (!fallbackResponse?.status) {
                setStore(null)
                toast.error(fallbackResponse?.message || 'Data toko tidak ditemukan')
                setStoreLoading(false)
                return
            }

            const fallbackStores = Array.isArray(fallbackResponse?.data)
                ? fallbackResponse.data
                : Array.isArray(fallbackResponse?.data?.data)
                ? fallbackResponse.data.data
                : []

            const selectedStore = pickStoreBySlug(fallbackStores, storeSlug)
            if (!selectedStore) {
                setStore(null)
                toast.error('Store tidak ditemukan untuk checkout ini')
                setStoreLoading(false)
                return
            }

            applyStoreData(selectedStore)
            setStoreLoading(false)
        } catch (error) {
            setStore(null)
            toast.error(error?.message || 'Gagal memuat data toko')
        } finally {
            setStoreLoading(false)
        }
    }

    const history = useNavigate()
    const location = useLocation()
    const locationStoreSlug = location?.state?.store_slug || ''
    const storeSlug = locationStoreSlug
    let storedCheckoutContext = {}
    try {
        storedCheckoutContext = JSON.parse(window.sessionStorage.getItem('order_checkout_context') || '{}')
    } catch (error) {
        storedCheckoutContext = {}
    }
    const selectedCartIds = (
        Array.isArray(location?.state?.selected_cart_ids)
            ? location.state.selected_cart_ids
            : Array.isArray(storedCheckoutContext?.selected_cart_ids)
                ? storedCheckoutContext.selected_cart_ids
                : []
    )
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id))
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        formState: { errors },
    } = useForm()

    const onSubmit = async (data) => {
        // console.log(data)
    }

    useEffect(() => {
        if (selectedCartIds.length === 0) {
            setValidParams(false)
            toast.error('Pilih produk dari keranjang untuk melanjutkan checkout')
            history('/product', { replace: true })
        } else {
            setValidParams(true)
        }
    }, [history, selectedCartIds.length])

    const FnDelivery = async () => {
        const params = {
            access: 'auth',
            url: API.DELIVERY.url,
            method: API.DELIVERY.type,
            reqBody: {}
        }
        try {
            const response = await Api(params)
            const deliveryData = Array.isArray(response?.data) ? response.data : []
            if (response.status && deliveryData.length > 0) {
                const mappedDelivery = deliveryData.map(mapDeliveryOption)
                setMasterDelivery(mappedDelivery)
            } else {
                setMasterDelivery([])
                setDelivery([])
                setSelectedDelivery(null)
            }


        } catch (error) {
            setMasterDelivery([])
            setDelivery([])
            setSelectedDelivery(null)
            toast.error(error.message)
        }
    }
    const FnMyVoucher = async () => {
        const params = {
            access: 'auth',
            url: API.REDEEM_VOUCHER.url,
            method: API.REDEEM_VOUCHER.type,
            reqBody: {
                page: 1,
                rows: 1000,
                category: 'marketplace',
                filter: [
                    {
                        field: "used",
                        operator: "=",
                        value: "0"
                    },
                    {
                        field: "expire_date",
                        operator: ">=",
                        value: moment().format('YYYY-MM-DD HH:mm:ss')
                    }
                ]
            }
        }
        try {
            const response = await Api(params)
            if (response.status) {
                setMyVouchers(response.data.data)
            }


        } catch (error) {
            toast.error(error.message)
        }
    }
    const FnGlobalVouchers = async (companySlug) => {
        if (!companySlug) {
            setGlobalVouchers([])
            return
        }
        try {
            const response = await Api({
                access: 'auth',
                url: API.GLOBAL_VOUCHER.url,
                method: API.GLOBAL_VOUCHER.type,
                reqBody: {
                    company_slug: companySlug,
                    items: carts.map((cart) => ({
                        item_id: cart.item_id,
                        item_sku: cart.item_sku || cart.sku,
                        item_name: cart.item_name
                    }))
                }
            })
            if (response?.status) {
                setGlobalVouchers((response.data || []).map((voucher) => ({
                    ...voucher,
                    voucher,
                    voucher_category: 'global',
                    is_global_voucher: true
                })))
            } else {
                setGlobalVouchers([])
            }
        } catch (error) {
            setGlobalVouchers([])
        }
    }

    const FnMSPayment = async (partnerId = null) => {
        const params = {
            access: 'auth',
            url: API.MS_PAYMENT.url,
            method: API.MS_PAYMENT.type,
            reqBody: partnerId ? { partner_id: partnerId } : {}
        }
        try {
            const response = await Api(params)
            const paymentData = Array.isArray(response?.data) ? response.data : []
            const companyPayments = paymentData.filter(isPaymentOption).map(mapPaymentOption)
            if (response.status && companyPayments.length > 0) {
                setMsPayment(companyPayments)

            } else {
                // toast.error(response.message)
                setMsPayment([])
                setStorePayment([])
                setSelectedPayment(null)
            }

        } catch (error) {
            setMsPayment([])
            setStorePayment([])
            setSelectedPayment(null)
            toast.error(error.message)
        }
    }
    const FnShipping = async (storeData, destinationAddress, selectedDeliveryOption, selectedPaymentOption) => {
        if (!selectedDeliveryOption) {
            setShipping({ costs: [] })
            setSelectedShipping(null)
            return
        }

        if (selectedDeliveryOption?.ms_delivery_identifier === 'PICKUP') {
            setShipping({ costs: [] })
            setSelectedShipping(null)
            return
        }

        if (isGoSendDelivery(selectedDeliveryOption)) {
            const originCoordinate = resolveCoordinatePair(storeData)
            const destinationCoordinate = resolveCoordinatePair(destinationAddress)
            const gosendPaymentType = toIdNumber(selectedPaymentOption?.ms_payment_id)
            if (!gosendPaymentType) {
                // Store/delivery and the company payment gateway are loaded in
                // parallel. Do not report the gateway as unavailable while its
                // request is still pending; this effect runs again once the
                // selected payment has been populated.
                setShipping({ costs: [] })
                setSelectedShipping(null)
                return
            }

            if (!originCoordinate || !destinationCoordinate) {
                setShipping({ costs: [] })
                setSelectedShipping(null)
                toast.error('Koordinat toko atau alamat belum lengkap untuk menghitung ongkir GoSend')
                return
            }

            const params = {
                access: 'auth',
                url: API.GOSEND_SHIPPING_COST.url,
                method: API.GOSEND_SHIPPING_COST.type,
                reqBody: {
                    origin: formatCoordinateForApi(originCoordinate),
                    destination: formatCoordinateForApi(destinationCoordinate),
                    paymentType: gosendPaymentType
                }
            }

            try {
                const response = await Api(params)
                const gosendCosts = normalizeGoSendCosts(response?.data).filter(isInstantShipping)

                if (gosendCosts.length > 0) {
                    setShipping({ costs: gosendCosts })
                    return
                }

                setShipping({ costs: [] })
                setSelectedShipping(null)
                toast.error(response?.error || response?.message || 'Harga GoSend tidak tersedia')
            } catch (error) {
                setShipping({ costs: [] })
                setSelectedShipping(null)
                toast.error(error.message)
            }

            return
        }

        const destinationCityId = resolveAddressCityId(destinationAddress)
        if (!storeData?.store_id || !destinationCityId) {
            setShipping({ costs: [] })
            setSelectedShipping(null)
            return
        }

        const params = {
            access: 'auth',
            url: API.SHIPPING.url,
            method: API.SHIPPING.type,
            reqBody: {
                store_id: storeData.store_id,
                destination: destinationCityId
            }
        }

        try {
            const response = await Api(params)
            if (response?.status) {
                setShipping(response?.data || { costs: [] })
            } else {
                setShipping({ costs: [] })
                setSelectedShipping(null)
            }
        } catch (error) {
            setShipping({ costs: [] })
            setSelectedShipping(null)
            toast.error(error.message)
        }
    }

    const FnAddress = async ({ redirectIfEmpty = false } = {}) => {
        try {
            const addressData = await getMemberAddresses()
            setAddress(addressData)
            const defaultAddress = addressData.find((e) => e.address_default === '1')
            setSelectedAddress(defaultAddress || addressData[0] || null)

            if (addressData.length === 0) {
                if (redirectIfEmpty) {
                    toast.error('Lengkapi alamat pengiriman terlebih dahulu')
                    setTimeout(() => {
                        history('/profile', { replace: true })
                    }, 700)
                }
                return false
            }

            return true
        } catch (error) {
            toast.error(error?.message || 'Gagal memeriksa alamat pengiriman')
            if (redirectIfEmpty) {
                setTimeout(() => {
                    history('/product', { replace: true })
                }, 700)
            }
            return false
        }
    }

    // console.log('Address', address)
    // console.log('selectedAddress', selectedAdderss)
    const FnPrice = () => {

    }

    const normalizeCartItems = (payload) => {
        if (!payload) return []
        if (Array.isArray(payload.items)) return payload.items
        if (Array.isArray(payload)) {
            if (payload.length && payload[0].items) {
                return payload.flatMap((g) =>
                    (g.items || []).map((item) => ({
                        ...item,
                        store_slug: item?.store_slug || g?.store_slug || '',
                        store_name: item?.store_name || g?.store_name || ''
                    }))
                )
            }
            return payload
        }
        if (payload.data && Array.isArray(payload.data)) {
            return normalizeCartItems(payload.data)
        }
        if (payload.data && payload.data.data && Array.isArray(payload.data.data)) {
            return normalizeCartItems(payload.data.data)
        }
        return []
    }
    const isItemChecked = (item) => {
        if (item?.checked === 1 || item?.checked === '1' || item?.checked === true) return true
        const normalized = `${item?.checked ?? ''}`.trim().toLowerCase()
        return normalized === '1' || normalized === 'true' || normalized === 'yes'
    }

    const FnCart = async (member_id) => {
        if (!member_id) {
            setCarts([])
            return
        }

        setCheckoutLoading(true)
        const params = {
            access: 'auth',
            method: API.CART.type,
            url: API.CART.url,
            reqBody: {
                page: 1,
                rows: 1000,
                store_slug: storeSlug
            }
        }
        try {
            const response = await Api(params)
            if (response?.status) {
                const items = normalizeCartItems(response.data)
                const selectedCartIdSet = new Set(selectedCartIds)
                const hasSelectedCartIds = selectedCartIdSet.size > 0
                const filteredItems = items.filter((item) => {
                    const itemCartId = Number(item?.cart_id)
                    const selectedById = hasSelectedCartIds
                        ? selectedCartIdSet.has(itemCartId)
                        : isItemChecked(item)
                    return selectedById
                })
                setCarts(filteredItems)
            } else {
                setCarts([])
                toast.error(response?.message || 'Gagal memuat item checkout')
            }
        } catch (error) {
            setCarts([])
            toast.error(error?.message || 'Terjadi kesalahan saat memuat item checkout')
        } finally {
            setCheckoutLoading(false)
        }
    }
    const resetCheckoutAfterCartMutation = () => {
        setServerPreview(null)
        setBalanceAllocation(null)
        setIsAgreementChecked(false)
        checkoutRequestIdRef.current = null
    }

    const deleteOrderCart = async (cart) => {
        const cartId = Number(cart?.cart_id)
        if (!Number.isFinite(cartId) || updatingCartIds.has(cartId)) return

        setUpdatingCartIds((previous) => new Set(previous).add(cartId))
        setCheckoutLoading(true)
        try {
            const response = await Api({
                access: 'auth', url: API.DELETE_CART.url, method: API.DELETE_CART.type,
                reqBody: { cart_id: cartId }
            })
            if (!response?.status) throw new Error(response?.message || 'Gagal menghapus produk dari keranjang')
            setCarts((previous) => previous.filter((item) => Number(item?.cart_id) !== cartId))
            resetCheckoutAfterCartMutation()
        } catch (error) {
            toast.error(error?.message || 'Gagal menghapus produk dari keranjang')
            const memberId = resolveMemberId(Auth)
            if (memberId) await FnCart(memberId)
        } finally {
            setUpdatingCartIds((previous) => { const next = new Set(previous); next.delete(cartId); return next })
            setCheckoutLoading(false)
        }
    }

    const updateOrderQuantity = async (cart, requestedQuantity) => {
        const cartId = Number(cart?.cart_id)
        if (Number(requestedQuantity) <= 0) return deleteOrderCart(cart)
        const stock = Number(cart?.available_quantity ?? cart?.menu_current_quantity ?? 0)
        const quantity = Math.max(1, Math.min(Number(requestedQuantity) || 1, stock || Number(requestedQuantity) || 1))
        if (!Number.isFinite(cartId) || quantity === Number(cart?.quantity) || updatingCartIds.has(cartId)) return

        setUpdatingCartIds((previous) => new Set(previous).add(cartId))
        setCheckoutLoading(true)
        try {
            const response = await Api({
                access: 'auth', url: API.EDIT_CART.url, method: API.EDIT_CART.type,
                reqBody: { cart_id: cartId, item_id: cart.item_id, quantity }
            })
            if (!response?.status) throw new Error(response?.message || 'Gagal memperbarui quantity')
            const selectedSet = new Set(selectedCartIds)
            const nextItems = normalizeCartItems(response.data).filter((item) => selectedSet.has(Number(item?.cart_id)))
            setCarts(nextItems.length ? nextItems : carts.map((item) => Number(item.cart_id) === cartId ? { ...item, quantity } : item))
            resetCheckoutAfterCartMutation()
        } catch (error) {
            toast.error(error?.message || 'Gagal memperbarui quantity')
            const memberId = resolveMemberId(Auth)
            if (memberId) await FnCart(memberId)
        } finally {
            setUpdatingCartIds((previous) => { const next = new Set(previous); next.delete(cartId); return next })
            setCheckoutLoading(false)
        }
    }
    useEffect(() => {
        if (!validParams) return
        if (orderInitializationStartedRef.current) return

        orderInitializationStartedRef.current = true

        setAddressGuardChecked(false)
        FnAddress({ redirectIfEmpty: true }).then((hasAddress) => {
            if (!hasAddress) return

            setAddressGuardChecked(true)
            auth()
                .then((data) => {
                    setAuth(data)
                    FnMSPayment(resolvePartnerId(data))
                    FnStore(resolvePartnerId(data))
                })
                .catch((error) => {
                    toast.error(error?.message || 'Gagal memuat sesi pengguna')
                })
            FnDelivery()
            FnMyVoucher()
        })
    }, [validParams])

    useEffect(() => {
        if (!canLoadOrder) return
        FnGlobalVouchers(resolveCheckoutCompanySlug(Store))
    }, [Store, carts, canLoadOrder])

    useEffect(() => {
        if (!canLoadOrder) return
        const filteredPayments = ms_payment.filter(isPaymentOption)
        const filteredDeliveries = masterDelivery.filter(
            (option) => `${option?.ms_delivery_identifier || ''}`.toUpperCase() === 'GOSEND'
        )

        setStorePayment(filteredPayments)
        setSelectedPayment((prevSelected) => {
            if (!prevSelected) return filteredPayments[0] || null
            const existing = filteredPayments.find((paymentOption) =>
                toIdNumber(paymentOption?.ms_payment_id) === toIdNumber(prevSelected?.ms_payment_id)
            )
            return existing || filteredPayments[0] || null
        })

        setDelivery(filteredDeliveries)
        setSelectedDelivery((prevSelected) => {
            if (!prevSelected) return filteredDeliveries[0] || null
            const existing = filteredDeliveries.find((deliveryOption) =>
                toIdNumber(deliveryOption?.ms_delivery_id) === toIdNumber(prevSelected?.ms_delivery_id)
            )
            return existing || filteredDeliveries[0] || null
        })
    }, [masterDelivery, ms_payment, canLoadOrder])
    useEffect(() => {
        if (!canLoadOrder) return
        const memberId = resolveMemberId(Auth)
        if (!memberId) return
        const requestKey = `${memberId}:${storeSlug}`
        if (initialCartLoadKeyRef.current === requestKey) return
        initialCartLoadKeyRef.current = requestKey
        FnCart(memberId)

    }, [Auth, canLoadOrder])
    useEffect(() => {
        if (!canLoadOrder) return
        let t = 0
        for (const d of carts) {
            const st = d.current_price * d.quantity
            t = t + st
        }
        setTotal(t)
    }, [carts, canLoadOrder])


    useEffect(() => {
        if (!canLoadOrder) return
        if (!Store || !selectedDelivery) return
        FnShipping(Store, selectedAdderss, selectedDelivery, selectedPayment)
    }, [Store, selectedAdderss, selectedDelivery, selectedPayment, canLoadOrder])

    useEffect(() => {
        if (!canLoadOrder) return
        if (shipping?.costs?.length > 0) {
            setSelectedShipping(shipping?.costs[0])
            return
        }
        setSelectedShipping(null)
    }, [shipping, canLoadOrder])

    useEffect(() => {
        if (!canLoadOrder) return
        // console.log('selectedShipping', selectedShipping)
    }, [selectedShipping, canLoadOrder])

    useEffect(() => {
        if (!canLoadOrder) return
        // console.log('Store', Store)
    }, [Store, canLoadOrder])

    useEffect(() => {
        if (!canLoadOrder || !selectedVoucher) return

        const checkoutCompanySlug = resolveCheckoutCompanySlug(Store)
        if (
            !voucherMatchesCompany(selectedVoucher, checkoutCompanySlug) ||
            !voucherMatchesItems(selectedVoucher, carts)
        ) {
            setSelectedVoucher(undefined)
        }
    }, [Store, selectedVoucher, carts, canLoadOrder])

    useEffect(() => {
        if (!isMidtransGateway(selectedPayment)) return
        const snapScript = process.env.REACT_APP_MIDTRANS_SNAP_SCRIPT
        if (!snapScript || document.querySelector(`script[src="${snapScript}"]`)) return
        const scriptTag = document.createElement('script')
        scriptTag.src = snapScript
        scriptTag.async = true
        document.body.appendChild(scriptTag)
    }, [selectedPayment])

    useEffect(() => {
        if (!canLoadOrder || checkoutSubmittingRef.current) return
        setIsAgreementChecked(false)
        setServerPreview(null)
        checkoutRequestIdRef.current = null
    }, [
        carts,
        selectedAdderss,
        selectedPayment,
        selectedDelivery,
        selectedShipping,
        selectedVoucher,
        transactionDeliveryNote,
        canLoadOrder
    ])



    useEffect(() => {
        if (!canLoadOrder) return
        // console.log('store_payment', store_payment)
    }, [store_payment, canLoadOrder])

    // console.log('store',Store)
    // console.log('partner_id',partner_id)
    // console.log('selectedAddress', selectedAdderss)
    // console.log('Shipping', shipping)
    // console.log('selectedShipping', selectedShipping)
    const handlePaymentMethodChange = async (e) => {
        // console.log(e)
    }
    const handleVoucherBtnClick = async (e) => {
        if (!resolveCheckoutCompanySlug(Store)) {
            toast.error('Data company toko belum tersedia')
            return
        }

        document.getElementById('select_voucher_modal').showModal()
    }

    const handleSelectVoucher = async (e) => {
        if (!['marketplace', 'global'].includes(e?.voucher_category || e?.voucher?.category)) {
            toast.error('Voucher ini hanya dapat digunakan di toko/offline')
            return
        }
        if (!voucherMatchesCompany(e, resolveCheckoutCompanySlug(Store))) {
            toast.error('Voucher tidak berlaku untuk company ini')
            return
        }

        if (!voucherMatchesItems(e, carts)) {
            toast.error('Voucher tidak berlaku untuk produk yang dipilih')
            return
        }

        setSelectedVoucher(e)
        document.getElementById("select_voucher_modal").close()
    }

    const handleRemoveVoucher = () => {
        setSelectedVoucher(undefined)
        toast.info('Voucher dilepas dari pesanan')
    }

    const handleSelectAddress = async (e) => {
        setSelectedAddress(e)
        document.getElementById("select_address_modal").close()
    }
    const handleSelectPayment = async (e) => {
        if (!isPaymentOption(e)) {
            toast.error('Payment gateway company tidak tersedia')
            return
        }

        setSelectedPayment(e)
        document.getElementById("select_payment_modal").close()
    }
    const handleSelectDelivery = async (e) => {
        setSelectedDelivery(e)
        document.getElementById("select_delivery_modal").close()
    }
    const handleSelectShipping = async (e) => {
        setSelectedShipping(e)
        document.getElementById("select_shipping_modal").close()
    }
    const buildTransactionPayload = () => {
        const selectedPaymentId = toIdNumber(selectedPayment?.ms_payment_id)
        const storeId = Store?.store_id || carts[0]?.store_id
        const deliveryIsPickup = `${selectedDelivery?.ms_delivery_identifier || ''}`.toUpperCase() === 'PICKUP'
        const payload = {
            item: carts.map((cart) => ({
                item_id: cart.item_id,
                item_name: cart.item_name,
                quantity: cart.quantity,
                note: cart.note
            })),
            store_id: storeId,
            store_slug: Store?.store_slug || storeSlug || carts[0]?.store_slug || undefined,
            company_slug: resolveCheckoutCompanySlug(Store) || undefined,
            ms_payment_id: selectedPaymentId,
            ms_delivery_id: selectedDelivery.ms_delivery_id,
            client_request_id: checkoutRequestIdRef.current,
            transaction_delivery_note: `${transactionDeliveryNote || ''}`.trim().slice(0, 255) || undefined
        }
        if (selectedVoucher) {
            if (selectedVoucher.is_global_voucher) {
                payload.voucher_code = `global:${selectedVoucher.voucher_id}`
            } else {
                payload.voucher_code = CryptoJS.AES.encrypt(
                    selectedVoucher.member_voucher_id.toString(),
                    selectedVoucher.voucher.partner.server_id
                ).toString()
            }
        }
        if (deliveryIsPickup) {
            payload.pickup_date = moment().format('YYYY-MM-DD HH:mm:00')
        } else {
            payload.shipping_destination = resolveAddressCityId(selectedAdderss)
            payload.shipping_destination_name = `${selectedAdderss?.address_name || ''}`.trim() || undefined
            payload.shipping_destination_address = composeShippingDestinationAddress(selectedAdderss)
            payload.shipping_destination_coordinate = composeShippingDestinationCoordinate(selectedAdderss)
            payload.shipping_service = selectedShipping?.service || undefined
        }
        return payload
    }

    const buildQuotePayload = () => ({
        selected_cart_ids: carts.map((cart) => Number(cart.cart_id)).filter(Number.isFinite),
        address_id: selectedAdderss?.address_id,
        partner_id: resolvePartnerId(Auth),
        ms_delivery_id: selectedDelivery?.ms_delivery_id || null,
        shipping_service: selectedShipping?.service || null,
        voucher_code: buildTransactionPayload().voucher_code || null,
        client_request_id: checkoutRequestIdRef.current,
        use_balance: useBalance,
        balance_amount: useBalance && balanceAmount !== '' ? Number(balanceAmount) : undefined,
        transaction_delivery_note: `${transactionDeliveryNote || ''}`.trim().slice(0, 255) || null
    })

    const currentCheckoutSummary = () => localCheckoutSummary({
        carts: serverPreview?.items?.length ? serverPreview.items : carts,
        subtotal: serverPreview?.subtotal ?? total,
        discount: serverPreview?.discount ?? voucherAmount,
        shipping: serverPreview?.shipping ?? shippingAmount,
        total: serverPreview?.total ?? grandTotal,
        shippingService: serverPreview?.shippingService || selectedShipping?.service,
        deliveryId: selectedDelivery?.ms_delivery_id,
        voucherCode: selectedVoucher?.voucher_code || selectedVoucher?.voucher?.voucher_code
    })

    const responsePaymentGateway = (response) =>
        response?.data?.payment_gateway || response?.data?.data?.payment_gateway || response?.payment_gateway || selectedPayment

    const handlePay = async () => {
        if (checkoutSubmittingRef.current || checkoutLoading || qrisPayment || paymentToken) return
        if (carts.length === 0) return toast.error('Tidak ada item checkout. Silakan pilih barang dari keranjang terlebih dahulu.')
        const firstName = `${Auth?.data?.firstname || Auth?.firstname || ''}`.trim()
        if (!firstName) {
            toast.error('Nama harus diisi')
            setTimeout(() => {
                history('/profile')
            }, 700)
            return
        }
        if (!selectedDelivery?.ms_delivery_id) return toast.error('Metode pengiriman belum dipilih')
        if (!toIdNumber(selectedPayment?.ms_payment_id)) return toast.error('Metode pembayaran tidak tersedia')
        if (!selectedAdderss?.address_id || !`${selectedAdderss?.coordinate || ''}`.trim()) return toast.error('Lengkapi alamat dan titik lokasi pengiriman terlebih dahulu')
        if (`${selectedDelivery?.ms_delivery_identifier || ''}`.toUpperCase() !== 'PICKUP' && !selectedShipping?.service) return toast.error('Jasa pengiriman belum dipilih')
        if (!isAgreementChecked) return toast.error('Silakan centang persetujuan terlebih dahulu')

        const storeId = Store?.store_id || carts[0]?.store_id
        if (!storeId) return toast.error('Data toko checkout belum tersedia')

        checkoutRequestIdRef.current = checkoutRequestIdRef.current || generateCheckoutRequestId()
        const localSummary = currentCheckoutSummary()
        const basePayload = buildQuotePayload()
        checkoutSubmittingRef.current = true
        setCheckoutLoading(true)
        try {
            const previewResponse = await Api({
                access: 'auth',
                url: API.CHECKOUT_QUOTE.url,
                method: API.CHECKOUT_QUOTE.type,
                timeout: 30000,
                reqBody: basePayload
            })
            if (!(previewResponse?.status || previewResponse?.success)) {
                toast.error(previewResponse?.message || previewResponse?.error || 'Verifikasi checkout gagal')
                return
            }

            const preview = checkoutPreviewSummary(previewResponse)
            setBalanceAllocation(previewResponse?.data?.payment_allocation || null)
            const comparison = compareCheckoutPreview(localSummary, preview)
            if (!comparison.matches) {
                setServerPreview(preview)
                setIsAgreementChecked(false)
                checkoutRequestIdRef.current = null
                toast.info(`Detail checkout berubah: ${comparison.differences.join(', ')}. Mohon periksa dan setujui ulang.`)
                return
            }

            const quoteToken = previewResponse?.data?.quote_token
            if (!quoteToken) {
                toast.error('Quote checkout tidak valid. Silakan coba lagi.')
                return
            }
			let delivery_scheduled_at = null
			if (previewResponse?.data?.delivery_schedule?.required) {
				delivery_scheduled_at = await requestDeliverySchedule(previewResponse.data.delivery_schedule)
				if (!delivery_scheduled_at) return toast.info('Pilih jadwal pengiriman untuk melanjutkan pembayaran.')
			}
            let createResponse = await Api({
                access: 'auth',
                url: API.CHECKOUT_COMMIT.url,
                method: API.CHECKOUT_COMMIT.type,
                timeout: 45000,
                reqBody: { quote_token: quoteToken, client_request_id: checkoutRequestIdRef.current, delivery_scheduled_at }
            })
            if (createResponse?.data?.requires_balance_confirmation) {
                const token = await requestBalanceToken()
                if (!token) return toast.info('Pembayaran saldo menunggu konfirmasi token.')
                createResponse = await Api({ access: 'auth', url: API.CHECKOUT_COMMIT.url, method: API.CHECKOUT_COMMIT.type, timeout: 45000, reqBody: { quote_token: quoteToken, client_request_id: checkoutRequestIdRef.current, delivery_scheduled_at, balance_confirmation_id: createResponse.data.confirmation_id, balance_confirmation_token: token } })
            }
            if (!(createResponse?.status || createResponse?.success)) {
                toast.error(createResponse?.message || createResponse?.error || 'Gagal membuat transaksi')
                return
            }

            const committedAllocation = createResponse?.data?.payment_allocation || previewResponse?.data?.payment_allocation || null
            if (committedAllocation && Number(committedAllocation.qris_amount || 0) === 0) {
                toast.success('Pesanan berhasil dibayar menggunakan saldo')
                history('/order/status/success', { replace: true })
                return
            }

            const paymentGateway = responsePaymentGateway(createResponse)
            if (isMidtransGateway(paymentGateway) && createResponse?.token) {
                setPaymentToken(createResponse.token)
                return
            }
            if (isXenditGateway(paymentGateway)) {
                const qrString = paymentGatewayPresentValue(paymentGateway, 'QR_STRING')
                if (qrString) {
                    setQrisPayment({
                        value: qrString,
                        gateway: paymentGateway,
                        amount: Number(committedAllocation?.qris_amount),
                        transaction: createResponse?.data?.transaction || createResponse?.data?.data || createResponse?.data || {}
                    })
                    return
                }
                const redirectUrl = paymentGatewayRedirectUrl(paymentGateway)
                if (isSafePaymentRedirectUrl(redirectUrl)) {
                    window.location.assign(redirectUrl)
                    return
                }
            }
            toast.error('Instruksi pembayaran tidak tersedia. Silakan lanjutkan pembayaran dari daftar transaksi.')
        } catch (error) {
            toast.error(error?.message || 'Terjadi kesalahan saat memproses pembayaran')
        } finally {
            checkoutSubmittingRef.current = false
            setCheckoutLoading(false)
        }
    }

    const handlePaySuccess = () => history('/order/status/success', { replace: true })
    const handlePayError = () => history('/order/status/error', { replace: true })
    const handlePayPending = () => history('/order/status/pending')
    const handlePayClose = () => {
        setPaymentToken(null)
        history('/order/status/nopay')
    }
    const fetchQrisStatus = useCallback(async () => {
        const transaction = qrisPayment?.transaction || {}
        const transactionId = transaction.transaction_id || transaction.id
        const transactionNumber = transaction.transaction_number || transaction.transaction_no || transaction.number
        if (!transactionId && !transactionNumber) return null
        const response = await Api({
            access: 'auth',
            url: API.TRANSACTION_GET.url,
            method: API.TRANSACTION_GET.type,
            reqBody: { transaction_id: transactionId, transaction_number: transactionNumber }
        })
        return response?.status ? response?.data?.payment_gateway || null : null
    }, [qrisPayment])

	const handleQrisSuccess = useCallback(async () => {
		if (afterPaymentScheduleBusyRef.current) return
		afterPaymentScheduleBusyRef.current = true
		try {
			const current = qrisPayment?.transaction || {}
			const response = await Api({
				access: 'auth', url: API.TRANSACTION_GET.url, method: API.TRANSACTION_GET.type,
				reqBody: { transaction_id: current.transaction_id || current.id, transaction_number: current.transaction_number || current.transaction_no || current.number }
			})
			const schedule = response?.status ? response?.data?.delivery_schedule : null
			if (schedule?.required_after_payment && !schedule?.scheduled_at) {
				const selectedAt = await requestDeliverySchedule(schedule, 'after_payment')
				if (!selectedAt) return
				const saved = await Api({ access: 'auth', url: API.TRANSACTION_DELIVERY_SCHEDULE.url, method: API.TRANSACTION_DELIVERY_SCHEDULE.type, reqBody: { transaction_id: current.transaction_id || current.id, delivery_scheduled_at: selectedAt } })
				if (!saved?.status) {
					toast.error(saved?.message || 'Gagal menyimpan jadwal pengiriman')
					return
				}
			}
			setQrisPayment(null)
			history('/transaction/list', { replace: true })
		} finally {
			afterPaymentScheduleBusyRef.current = false
		}
	}, [history, qrisPayment])

    const selectedShippingLabel = getShippingLabel(selectedShipping)
    const selectedShippingSubtitle = getShippingSubtitle(selectedShipping)
    const selectedShippingPrice = getShippingPriceValue(selectedShipping)
    if (!canLoadOrder) {
        return (
            <div className="min-h-screen bg-gray-50">
                <ToastContainer autoClose={1000} />
                <div className="mx-auto max-w-sm px-4 py-6">
                    <Card className="shadow-sm">
                        <Card.Body className="p-4 text-center text-sm text-gray-600">
                            Memeriksa alamat pengiriman...
                        </Card.Body>
                    </Card>
                </div>
            </div>
        )
    }

    const checkoutCompanySlug = resolveCheckoutCompanySlug(Store)
    const eligibleVouchers = [
        ...my_vouchers.filter((voucher) =>
        (voucher?.voucher_category || voucher?.voucher?.category) === 'marketplace' &&
        voucherMatchesCompany(voucher, checkoutCompanySlug) &&
        voucherMatchesItems(voucher, carts)
        ),
        ...globalVouchers.filter((voucher) =>
            voucherMatchesCompany(voucher, checkoutCompanySlug) &&
            voucherMatchesItems(voucher, carts)
        )
    ]
    const subtotalAmount = total
    const shippingAmount = selectedDelivery?.ms_delivery_identifier === 'PICKUP' ? 0 : selectedShippingPrice
    const voucherAmount = getVoucherDiscountAmount(selectedVoucher, subtotalAmount, {
        shippingAmount,
        items: carts
    })
    const selectedVoucherDiscountMeta = selectedVoucher ? getVoucherDiscountMeta(selectedVoucher) : null
    const selectedVoucherDiscountText = selectedVoucherDiscountMeta?.type === 'percentage'
        ? `-${formatIDR(voucherAmount)} (${selectedVoucherDiscountMeta.label})`
        : selectedVoucherDiscountMeta?.type === 'fixed_amount'
            ? `-${formatIDR(voucherAmount)}`
            : selectedVoucherDiscountMeta?.type === 'free_delivery'
                ? `-${formatIDR(voucherAmount)} (${selectedVoucherDiscountMeta.label})`
                : selectedVoucherDiscountMeta?.label || '-'
    const grandTotal = Math.max(0, subtotalAmount + shippingAmount - voucherAmount)
    const displayedSubtotalAmount = serverPreview?.subtotal ?? subtotalAmount
    const displayedShippingAmount = serverPreview?.shipping ?? shippingAmount
    const displayedVoucherAmount = serverPreview?.discount ?? voucherAmount
    const displayedGrandTotal = serverPreview?.total ?? grandTotal
    const selectedVoucherName = selectedVoucher?.voucher?.name || selectedVoucher?.voucher_name || 'Voucher'
    const midtransClientKey = selectedPayment?.public_configuration?.client_key ||
        (selectedPayment?.configuration_source === 'ENV_FALLBACK' ? process.env.REACT_APP_CLIENT_KEY_MIDTRANS : null)
    const orderReviewDisabled = carts.length === 0 || !selectedShipping || !isAgreementChecked || checkoutLoading || storeLoading || Boolean(qrisPayment) || Boolean(paymentToken)
    const orderReviewButtonStyle = orderReviewDisabled
        ? {}
        : {
            background: `linear-gradient(135deg, ${primaryColor || '#2563eb'}, ${primaryColorHover || primaryColor || '#1d4ed8'})`,
            boxShadow: '0 10px 20px rgba(37, 99, 235, 0.24)'
        }

    return (
        <div className="min-h-screen bg-gray-50">
            <ToastContainer autoClose={1000} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mx-auto max-w-sm px-4 py-4 space-y-3">

                    <Card className="bg-white shadow-sm rounded-xl">
                        <Card.Body className="p-4 space-y-1.5">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-[11px] text-gray-500">Ringkasan Pesanan</p>
                                    <h1 className="text-base font-medium text-gray-800">Checkout</h1>
                                </div>
                                <div className="text-right">
                                    <p className="text-[11px] text-gray-500">Total</p>
                                    <p className="text-sm font-medium text-gray-800">{formatIDR(displayedGrandTotal)}</p>
                                </div>
                            </div>
                            <p className="text-xs text-gray-600">{carts?.length || 0} item dipilih</p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <div className="flex items-center justify-between">
                                <h2 className="text-sm font-medium text-gray-800">Metode Pengiriman</h2>
                                <a href="#select_delivery_modal" className="text-xs font-medium  hover:text-red-800" onClick={(event) => { event.preventDefault(); document.getElementById('select_delivery_modal').showModal() }}>
                                    Ganti
                                </a>
                            </div>
                            <div className="flex justify-between text-xs text-gray-700">
                                <span>{selectedDelivery?.ms_delivery_name || '-'}</span>
                            </div>
                        </Card.Body>
                    </Card>

                    {selectedDelivery?.ms_delivery_identifier === 'PICKUP' ? (
                        <Card className="shadow-sm">
                            <Card.Body className="space-y-2 text-xs text-gray-700">
                                <h2 className="text-sm font-medium text-gray-800">Pengambilan</h2>
                                <p>Anda bisa mengambil pesanan di:</p>
                                <p className="font-medium">{storeLoading ? 'Memuat data toko...' : (Store?.store_name || '-')}</p>
                                <p>{Store?.store_address || '-'}</p>
                                <p>Jam operasional: {Store?.store_operation_time || '-'}</p>
                            </Card.Body>
                        </Card>
                    ) : (
                        <>
                            <Card className="shadow-sm">
                                <Card.Body className="space-y-3">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-sm font-medium text-gray-800">Alamat Pengiriman</h2>
                                        <a href="#select_address_modal" className="text-xs font-medium  hover:text-red-800" onClick={(event) => { event.preventDefault(); document.getElementById('select_address_modal').showModal() }}>
                                            Ganti
                                        </a>
                                    </div>
                                    <div className="p-3 bg-gray-50 rounded-lg text-xs text-gray-700">
                                        <div className="font-medium">{selectedAdderss?.address_name}</div>
                                        <div dangerouslySetInnerHTML={{ __html: selectedAdderss?.full_address }} />
                                        <div>{selectedAdderss?.city_name} - {selectedAdderss?.province_name} {selectedAdderss?.postal_code}</div>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm">
                                <Card.Body className="space-y-3">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-sm font-medium text-gray-800">Ongkos Kirim</h2>
                                        <a href="#select_shipping_modal" className="text-xs font-medium  hover:text-red-800" onClick={(event) => { event.preventDefault(); document.getElementById('select_shipping_modal').showModal() }}>
                                            Ganti
                                        </a>
                                    </div>
                                    <div className="flex justify-between text-xs text-gray-700">
                                        <span>
                                            {selectedShippingLabel}
                                            {selectedShippingSubtitle ? ` (${selectedShippingSubtitle})` : ''}
                                        </span>
                                        <span>{selectedShipping ? formatIDR(selectedShippingPrice) : '-'}</span>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm">
                                <Card.Body className="space-y-2">
                                    <label htmlFor="transaction_delivery_note" className="text-sm font-medium text-gray-800">
                                        Catatan untuk kurir
                                    </label>
                                    <textarea
                                        id="transaction_delivery_note"
                                        className="textarea textarea-bordered min-h-20 w-full resize-none text-xs text-gray-700 placeholder:text-gray-400"
                                        maxLength={255}
                                        placeholder="Contoh: Titip di security, hubungi sebelum sampai"
                                        value={transactionDeliveryNote}
                                        onChange={(event) => setTransactionDeliveryNote(event.target.value.slice(0, 255))}
                                    />
                                    <div className="text-right text-[11px] text-gray-400">
                                        {transactionDeliveryNote.length}/255
                                    </div>
                                </Card.Body>
                            </Card>
                        </>
                    )}
                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <div className="flex items-center justify-between">
                                <h2 className="text-sm font-medium text-gray-800">Pesanan</h2>
                                <span className="text-xs text-gray-500">{carts?.length || 0} item</span>
                            </div>
                            {checkoutLoading ? (
                                <div className="space-y-2 animate-pulse">
                                    {[...Array(2)].map((_, i) => (
                                        <div key={i} className="h-16 rounded-lg bg-gray-100" />
                                    ))}
                                </div>
                            ) : carts.length === 0 ? (
                                <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-3 py-4 text-sm text-gray-600">
                                    <p>Tidak ada produk di cart.</p>
                                    <button
                                        type="button"
                                        className="mt-2 text-xs font-medium text-blue-600 hover:text-blue-700"
                                        onClick={() => history('/product')}
                                    >
                                        Tambah Produk
                                    </button>
                                </div>
                            ) : (
                                <div className="divide-y">
                                    {carts?.map((d, i) => (
                                        <div key={d?.cart_id || i} className="py-3 flex gap-3">
                                            <img src={d?.item_image} alt="" className="w-14 h-14 rounded-lg object-cover bg-gray-100" />
                                            <div className="flex-1 min-w-0">
                                                <div className="font-medium text-xs text-gray-800 line-clamp-2">{d?.item_name}</div>
                                                <div className="mt-2 flex items-center gap-2">
                                                    <button type="button" aria-label={Number(d?.quantity) <= 1 ? 'Hapus produk' : 'Kurangi quantity'} className="btn btn-xs" disabled={checkoutLoading || updatingCartIds.has(Number(d?.cart_id))} onClick={() => updateOrderQuantity(d, Number(d?.quantity) - 1)}>−</button>
                                                    <span className="min-w-6 text-center text-xs font-semibold">{d?.quantity}</span>
                                                    <button type="button" aria-label="Tambah quantity" className="btn btn-xs" disabled={checkoutLoading || updatingCartIds.has(Number(d?.cart_id)) || Number(d?.quantity) >= Number(d?.available_quantity ?? d?.menu_current_quantity ?? 0)} onClick={() => updateOrderQuantity(d, Number(d?.quantity) + 1)}>+</button>
                                                    <span className="text-[11px] text-gray-500">Stok: {d?.available_quantity ?? d?.menu_current_quantity ?? '-'}</span>
                                                </div>
                                                <div className="text-xs text-gray-500">Harga satuan: {formatIDR(d?.current_price || 0)}</div>
                                                {providerStoreName && (
                                                    <div className="text-xs text-gray-500">Toko penyedia: {providerStoreName}</div>
                                                )}
                                            </div>
                                            <div className="text-right text-xs font-medium text-gray-800">
                                                {formatIDR(d?.quantity * d?.current_price)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <div className="flex items-center justify-between">
                                <h2 className="text-sm font-medium text-gray-800">Voucher</h2>
                                {storeLoading || !checkoutCompanySlug ? (
                                    <span className="text-xs text-gray-400">Pilih Voucher</span>
                                ) : (
                                    <a href="#select_voucher_modal" className="text-xs font-medium  hover:text-red-800" onClick={(event) => { event.preventDefault(); handleVoucherBtnClick() }}>
                                        Pilih Voucher
                                    </a>
                                )}
                            </div>
                            {selectedVoucher ? (
                                <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                                    <div className="flex items-center gap-3">
                                        <img className="max-h-12 rounded" src={selectedVoucher.voucher.voucher_image} alt="" />
                                        <div>
                                            <p className="text-xs font-medium text-gray-800">{selectedVoucher.voucher.name}</p>
                                            <p className="text-xs text-red-600">{selectedVoucherDiscountText}</p>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleRemoveVoucher}
                                        disabled={checkoutLoading || Boolean(qrisPayment) || Boolean(paymentToken)}
                                        className="shrink-0 text-xs font-medium text-red-600 hover:text-red-700 hover:underline disabled:cursor-not-allowed disabled:text-gray-400"
                                    >
                                        Hapus
                                    </button>
                                </div>
                            ) : (
                                <p className="text-xs text-gray-500 italic">Tidak ada voucher dipasang</p>
                            )}
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <div className="flex items-center justify-between">
                                <h2 className="text-sm font-medium text-gray-800">Metode Pembayaran</h2>
                                <a href="#select_payment_modal" className="text-xs font-medium  hover:text-red-800" onClick={(event) => { event.preventDefault(); document.getElementById('select_payment_modal').showModal() }}>
                                    Ganti
                                </a>
                            </div>
                            <div className="flex justify-between text-xs text-gray-700">
                                <span>{paymentDisplayName(selectedPayment)}</span>
                            </div>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <div className="flex items-center justify-between">
                                <div><h2 className="text-sm font-medium text-gray-800">Gunakan Saldo</h2><p className="text-xs text-gray-500">Tersedia {formatIDR(walletSummary?.available_balance || 0)}</p></div>
                                <input type="checkbox" className="toggle toggle-primary" checked={useBalance} disabled={!walletSummary?.available_balance || checkoutLoading} onChange={(event) => { setUseBalance(event.target.checked); setIsAgreementChecked(false); setBalanceAllocation(null); if (!event.target.checked) setBalanceAmount('') }} />
                            </div>
                            {useBalance && <><input inputMode="numeric" className="input input-bordered w-full text-sm" placeholder="Nominal saldo (kosongkan untuk memakai maksimum)" value={balanceAmount} onChange={(event) => { setBalanceAmount(event.target.value.replace(/\D/g, '')); setIsAgreementChecked(false); setBalanceAllocation(null) }} />{balanceAllocation && <div className="rounded bg-blue-50 p-2 text-xs text-blue-800"><div className="flex justify-between"><span>Saldo digunakan</span><span>{formatIDR(balanceAllocation.balance_amount)}</span></div><div className="mt-1 flex justify-between"><span>Sisa QRIS</span><span>{formatIDR(balanceAllocation.qris_amount)}</span></div></div>}</>}
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body className="space-y-3">
                            <h2 className="text-sm font-medium text-gray-800">Total Belanjaan</h2>
                            <div className="space-y-2 text-xs text-gray-700">
                                <div className="flex justify-between gap-4">
                                    <span>Subtotal ({carts.length} item)</span>
                                    <span>{formatIDR(displayedSubtotalAmount)}</span>
                                </div>
                                <div className="flex justify-between gap-4">
                                    <span>Ongkos Kirim</span>
                                    <span>{formatIDR(displayedShippingAmount)}</span>
                                </div>
                                {selectedVoucher && displayedVoucherAmount > 0 ? (
                                    <div className="flex justify-between gap-4 text-red-600">
                                        <span>Voucher {selectedVoucherName}</span>
                                        <span>- {formatIDR(displayedVoucherAmount)}</span>
                                    </div>
                                ) : null}
                            </div>
                            <div className="flex justify-between border-t border-gray-200 pt-3 text-sm font-semibold text-gray-800">
                                <span>Total</span>
                                <span>{formatIDR(displayedGrandTotal)}</span>
                            </div>
                        </Card.Body>
                    </Card>

                    {serverPreview ? (
                        <Card className="border border-amber-200 bg-amber-50 shadow-sm">
                            <Card.Body className="space-y-1 p-3 text-xs text-amber-800">
                                <p className="font-medium">Detail checkout berubah. Mohon periksa dan setujui ulang sebelum membayar.</p>
                                {serverPreview.total !== null ? <p>Total terbaru dari server: {formatIDR(serverPreview.total)}</p> : null}
                            </Card.Body>
                        </Card>
                    ) : null}

                    <Card className="shadow-sm">
                        <Card.Body className="p-3">
                            <label className="flex cursor-pointer items-start gap-2 text-xs text-gray-700">
                                <input
                                    type="checkbox"
                                    className="checkbox checkbox-sm mt-0.5"
                                    checked={isAgreementChecked}
                                    onChange={(event) => setIsAgreementChecked(event.target.checked)}
                                    disabled={checkoutLoading || Boolean(qrisPayment) || Boolean(paymentToken)}
                                />
                                <span>Saya menyetujui detail pesanan, alamat pengiriman, biaya pengiriman, total pembayaran, serta syarat dan ketentuan yang berlaku.</span>
                            </label>
                        </Card.Body>
                    </Card>

                    <div>
                        <button
                            className={`btn h-10 min-h-0 w-full border-none text-sm font-semibold text-white transition-all duration-200 ${
                                orderReviewDisabled
                                    ? 'bg-gray-300 text-gray-100 shadow-none'
                                    : 'hover:-translate-y-0.5 hover:brightness-105 active:translate-y-0'
                            }`}
                            style={orderReviewButtonStyle}
                            type="button"
                            onClick={handlePay}
                            disabled={orderReviewDisabled}
                        >
                            {checkoutLoading || storeLoading ? 'Memproses...' : 'Bayar'}
                        </button>
                    </div>

                </div>
            </form>

            {paymentToken && isMidtransGateway(selectedPayment) ? (
                <MidT
                    clientKey={midtransClientKey}
                    token={paymentToken}
                    onSuccess={handlePaySuccess}
                    onError={handlePayError}
                    onPending={handlePayPending}
                    onClose={handlePayClose}
                />
            ) : null}

            {qrisPayment?.value ? (
                <QrisPaymentModal
                    payment={qrisPayment}
                    storePhone={Store?.store_phone || qrisPayment?.transaction?.store?.store_phone || qrisPayment?.transaction?.store_phone}
                    onFetchStatus={fetchQrisStatus}
                    onClose={() => {
                        setQrisPayment(null)
                        history('/transaction/list', { replace: true })
                    }}
                    onExpired={() => {}}
					onSuccess={handleQrisSuccess}
                />
            ) : null}

            {/* Voucher Modal */}
            <dialog id="select_voucher_modal" className="modal">
                <div className="modal-box w-full">
                    <h3 className="mb-3 text-base font-medium">Voucher checkout</h3>
                    <div className="space-y-3">
                        {eligibleVouchers.length === 0 ? (
                            <p className='rounded-md bg-gray-50 p-3 text-xs text-gray-500'>Tidak ada voucher yang berlaku untuk produk yang dipilih.</p>
                        ) : eligibleVouchers.map((v, i) => (
                            <div key={i} className='flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer' onClick={() => handleSelectVoucher(v)}>
                                <img className="max-h-14 rounded" src={v.voucher.voucher_image} alt="" />
                                <div>
                                    <div className='text-sm font-medium'>{v.voucher.name}</div>
                                    <div className='text-xs text-red-600'>{getVoucherDiscountMeta(v).label}</div>
                                    {v.is_global_voucher && <div className='mt-1 text-[11px] text-green-600'>Voucher global</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='flex justify-end mt-4'>
                        <button className='btn h-8 min-h-0 px-3 text-xs text-white font-normal' onClick={() => document.getElementById('select_voucher_modal').close()}>Batal</button>
                    </div>
                </div>
            </dialog>

            {/* Address Modal */}
            <dialog id="select_address_modal" className="modal">
                <div className="modal-box w-full">
                    <h3 className="mb-3 text-base font-medium">Pilih Alamat</h3>
                    <div className="space-y-2">
                        {address.map((a, i) => (
                            <div key={i} className='flex flex-col gap-1 hover:cursor-pointer hover:bg-gray-100 p-3 border rounded-xl' onClick={() => handleSelectAddress(a)}>
                                <div className='text-sm font-medium'>{a.address_name}</div>
                                <div className='text-xs text-gray-700' dangerouslySetInnerHTML={{ __html: a.full_address }} />
                                <div className='text-xs text-gray-600'>{a.city_name} - {a.province_name}</div>
                                <div className='text-xs text-gray-600'>{a.postal_code}</div>
                            </div>
                        ))}
                    </div>
                    <div className='flex justify-end mt-4'>
                        <button className='btn h-8 min-h-0 px-3 text-xs text-white font-normal' onClick={() => document.getElementById('select_address_modal').close()}>Batal</button>
                    </div>
                </div>
            </dialog>

            {/* Shipping Modal */}
            <dialog id="select_payment_modal" className="modal">
                <div className="modal-box w-full">
                    <h3 className="mb-3 text-base font-medium">Pilih Metode Pembayaran</h3>
                    <div className='text-xs space-y-2'>
                        {store_payment?.length > 0 ? (
                            store_payment.map((paymentOption, i) => (
                                <div
                                    key={paymentOption?.ms_payment_id || i}
                                    className='flex justify-between items-center hover:cursor-pointer min-h-10 border rounded-md p-4 hover:bg-gray-100'
                                    onClick={() => handleSelectPayment(paymentOption)}
                                >
                                    <div>{paymentDisplayName(paymentOption)}</div>
                                </div>
                            ))
                        ) : (
                            <p className='rounded-md bg-gray-50 p-3 text-gray-500'>Metode pembayaran tidak tersedia.</p>
                        )}
                    </div>
                    <div className='flex justify-end mt-4'>
                        <button className='btn h-8 min-h-0 px-3 text-xs font-normal text-white' onClick={() => document.getElementById('select_payment_modal').close()}>Batal</button>
                    </div>
                </div>
            </dialog>

            <dialog id="select_delivery_modal" className="modal">
                <div className="modal-box w-full">
                    <h3 className="mb-3 text-base font-medium">Pilih Metode Pengiriman</h3>
                    <div className='text-xs space-y-2'>
                        {delivery?.length > 0 ? (
                            delivery.map((deliveryOption, i) => (
                                <div
                                    key={deliveryOption?.ms_delivery_id || i}
                                    className='flex justify-between items-center hover:cursor-pointer min-h-10 border rounded-md p-4 hover:bg-gray-100'
                                    onClick={() => handleSelectDelivery(deliveryOption)}
                                >
                                    <div>{deliveryOption?.ms_delivery_name || '-'}</div>
                                </div>
                            ))
                        ) : (
                            <p className='rounded-md bg-gray-50 p-3 text-gray-500'>Metode pengiriman tidak tersedia.</p>
                        )}
                    </div>
                    <div className='flex justify-end mt-4'>
                        <button className='btn h-8 min-h-0 px-3 text-xs font-normal text-white' onClick={() => document.getElementById('select_delivery_modal').close()}>Batal</button>
                    </div>
                </div>
            </dialog>

            <dialog id="select_shipping_modal" className="modal">
                <div className="modal-box w-full">
                    <h3 className="mb-3 text-base font-medium">Pilih Jasa Pengiriman</h3>
                    <div className='text-xs space-y-2'>
                        {shipping?.costs?.length > 0 ? (
                            shipping?.costs?.map((s, i) => (
                                <div key={i} className='flex justify-between items-center hover:cursor-pointer min-h-10 border rounded-md p-4 hover:bg-gray-100' onClick={() => handleSelectShipping(s)}>
                                    <div>
                                        {getShippingLabel(s)}
                                        {getShippingSubtitle(s) ? ` (${getShippingSubtitle(s)})` : ''}
                                    </div>
                                    <div>{formatIDR(getShippingPriceValue(s))}</div>
                                </div>
                            ))
                        ) : (
                            <p className='rounded-md bg-gray-50 p-3 text-gray-500'>Belum ada opsi jasa pengiriman.</p>
                        )}
                    </div>
                    <div className='flex justify-end mt-4'>
                        <button className='btn h-8 min-h-0 px-3 text-xs font-normal text-white' onClick={() => document.getElementById('select_shipping_modal').close()}>Batal</button>
                    </div>
                </div>
            </dialog>

            <dialog id="balance_confirmation_modal" className="modal">
                <div className="modal-box max-w-md rounded-3xl">
                    <h3 className="text-2xl font-bold text-slate-900">Masukkan kode OTP</h3>
                    <p className="mt-1 text-sm text-slate-500">Token 6 digit telah dikirim ke WhatsApp Anda.</p>
                    <label className="relative mt-6 block cursor-text">
                        <div className="grid grid-cols-6 gap-2">{Array.from({ length: 6 }, (_, index) => <div key={index} className={`flex aspect-square items-center justify-center rounded-xl border-2 text-2xl font-bold ${balanceConfirmationToken[index] ? 'border-blue-600 bg-white text-slate-900' : 'border-stone-200 bg-stone-50 text-stone-300'}`}>{balanceConfirmationToken[index] || ''}</div>)}</div>
                        <input autoFocus value={balanceConfirmationToken} onChange={(event) => setBalanceConfirmationToken(event.target.value.replace(/\D/g, '').slice(0, 6))} inputMode="numeric" maxLength="6" className="absolute inset-0 h-full w-full opacity-0" />
                    </label>
                    <p className="mt-5 rounded-2xl bg-stone-50 p-3 text-xs text-slate-600">Jangan bagikan token ini kepada siapa pun. Pembayaran saldo diproses setelah token diverifikasi.</p>
                    <div className="mt-5 flex gap-3"><button className="btn flex-1 text-white" onClick={() => { document.getElementById('balance_confirmation_modal')?.close(); balanceTokenResolverRef.current?.(null) }}>Batal</button><button disabled={balanceConfirmationToken.length !== 6} className="btn flex-1 bg-blue-600 text-white" onClick={() => { const token = balanceConfirmationToken; document.getElementById('balance_confirmation_modal')?.close(); balanceTokenResolverRef.current?.(token) }}>Konfirmasi</button></div>
                </div>
            </dialog>

			<dialog id="delivery_schedule_modal" className="modal">
				<div className="modal-box max-w-md rounded-3xl">
					<h3 className="text-xl font-bold text-slate-900">Jadwalkan pengiriman</h3>
					<p className="mt-2 text-sm text-slate-600">{deliveryScheduleMode === 'after_payment' ? 'Pembayaran telah diterima. Pilih waktu pengiriman saat toko buka untuk menyelesaikan pesanan.' : 'Toko sedang di luar jam operasional. Pilih waktu pengiriman saat toko buka; pembayaran dilanjutkan setelah jadwal dipilih.'}</p>
					<p className="mt-4 text-xs text-slate-500">Jam operasional yang tersedia: {deliveryScheduleBounds().min.replace('T', ' ')} – {deliveryScheduleBounds().max.replace('T', ' ')}</p>
					<input type="datetime-local" className="input input-bordered mt-2 w-full" value={deliveryScheduledAt} min={deliveryScheduleBounds().min || undefined} max={deliveryScheduleBounds().max || undefined} step="300" onChange={(event) => setDeliveryScheduledAt(event.target.value)} />
					{deliveryScheduledAt && !isDeliveryScheduleSelectionValid() && <p className="mt-2 text-xs text-error">Pilih jam yang berada dalam jam operasional toko.</p>}
					<div className="mt-5 flex gap-3"><button className="btn flex-1 text-white" onClick={() => { document.getElementById('delivery_schedule_modal')?.close(); deliveryScheduleResolverRef.current?.(null) }}>Batal</button><button disabled={!isDeliveryScheduleSelectionValid()} className="btn flex-1 bg-blue-600 text-white" onClick={() => { const value = new Date(deliveryScheduledAt).toISOString(); document.getElementById('delivery_schedule_modal')?.close(); deliveryScheduleResolverRef.current?.(value) }}>{deliveryScheduleMode === 'after_payment' ? 'Simpan Jadwal' : 'Lanjutkan'}</button></div>
				</div>
			</dialog>
        </div>
    )
}

export default Order
